export const lang = {
	TITLE: 'Fancy an upgrade?',
	SUBTITLE: 'Check out what you can add to your current plan here',
	CTA: 'Upgrade'
};
